exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainProduct__imgWrap{-ms-flex:0 0 50%;flex:0 0 50%;position:relative}.mainProduct__img{cursor:pointer;width:100%}@media only screen and (max-width:935px){.mainProduct__imgWrap{-ms-flex:0 0 50%;flex:0 0 50%}}@media only screen and (max-width:730px){.mainProduct__imgWrap{-ms-flex:0 0 100%;flex:0 0 100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-562687f7","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mainImg.vue
// module id = 27
// module chunks = 0